/**
 * LLM outputs often wrap the entire report in one fenced block (``` or ```markdown).
 * ReactMarkdown would render that as a single <pre>; peel one or more outer wrappers.
 */
export function unwrapOuterMarkdownFence(raw) {
  if (typeof raw !== "string") return raw
  let s = raw.replace(/^\uFEFF/, "")
  for (let depth = 0; depth < 4; depth++) {
    const lines = s.split(/\r?\n/)
    if (lines.length < 3) break
    const first = lines[0].trim()
    const last = lines[lines.length - 1].trim()
    if (!first.startsWith("```") || last !== "```") break
    s = lines.slice(1, -1).join("\n")
  }
  return s
}
